module.exports = __webpack_public_path__ + "static/img/09.96fe24d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/09.png
// module id = 8wL9
// module chunks = 0